import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { ExamFormValues } from "pages/CourseCreate/Exams/ExamForm";
import { CourseExampPaymentApi } from "pages/CourseCreate/Exams/ExamPaymentPoliciesPreview/ExamPaymentPoliciesPreview";
import { ExamStatusIds } from "consts";

const fetchByCourseId = (courseId: number): AxiosPromise<CourseExamApi[]> => {
  return api.get<CourseExamApi[]>(endpoints.COURSE_EXAMS.GET_BY_COURSEID(courseId));
};
const fetchWithStudents = (courseId: number): AxiosPromise<ExamWithStudentsResponse> => {
  return api.get<ExamWithStudentsResponse>(endpoints.COURSE_EXAMS.GET_WITH_STUDENTS_BY_COURSE_ID(courseId));
};
const fetchByIdWithStudents = (courseId: number, courseExamId: number): AxiosPromise<ExamDetails> => {
  return api.get<ExamDetails>(endpoints.COURSE_EXAMS.GET_WITH_STUDENTS_BY_ID(courseId, courseExamId));
};

const createExam = (courseId: number, exam: ExamBody): AxiosPromise => {
  return api.post(endpoints.COURSE_EXAMS.CREATE(courseId), exam);
};

const update = (courseId: number, examId: number, exam: ExamBody): AxiosPromise => {
  return api.put(endpoints.COURSE_EXAMS.UPDATE(courseId, examId), exam);
};

const deleteExam = (courseId: number, examId: number): AxiosPromise => {
  return api.delete(endpoints.COURSE_EXAMS.DELETE(courseId, examId));
};

const publishResults = (courseId: number, students: { userId: number; userExamId: number }[]): AxiosPromise => {
  return api.post(endpoints.COURSE_EXAMS.PUBLISH_RESULTS(courseId), { students });
};

export const courseExamsApi = {
  fetchByCourseId,
  create: createExam,
  delete: deleteExam,
  update,
  fetchWithStudents,
  fetchByIdWithStudents,
  publishResults,
};

export interface ExamBody {
  id?: number;
  examId: number;
  name: string;
  description?: string;
  day: Date;
  timeFrom: string;
  timeTo: string;
  courseSessionId: number;
  placeType: number;
  placeId?: number;
  trainerIds: number[];
  payments: ExamFormValues["payments"];
}
export interface CourseExamTrainerApi {
  trainerId: number;
  firstName: string;
  surname: string;
}
export interface CourseExamApi {
  id: number;
  examId: number;
  isSystem: boolean;
  name: string;
  day?: Date;
  timeFrom?: string;
  timeTo?: string;
  courseSessionId?: number;
  placeType?: number;
  placeId?: number;
  description: string;
  payments: CourseExampPaymentApi[];
  trainers: CourseExamTrainerApi[];
}

export interface ExamWithStudentsResponse {
  exams: ExamDetails[];
}
export interface ExamDetails {
  courseExamId: number;
  name: string;
  description: string;
  students: ExamStudent[];
}

export interface ExamStudent {
  user: {
    id: number;
    firstName: string;
    avatar: string;
    surname: string;
    email: string;
  };
  attempts: ExamStudentAttempt[];
}

export interface ExamStudentAttempt {
  userExamId: number;
  status: ExamStatusIds;
  comment: string;
  createdDate: Date;
  fillingDate: Date;
}
